var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
    ..._vm.containerStyle,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  })},[_c('div',{style:({
      ..._vm.containerBgStyle,
      position: 'absolute',
      zIndex: 0,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundPositionX: 'center',
    })}),(_vm.isShowFloatTop)?_c('FloatTop',{attrs:{"pageName":"MicrositeThankyouGame","campaign":_vm.campaign,"isShowRedirectHome":_vm.isShowFloatTop}}):_vm._e(),_c('FloatBottom',{attrs:{"pageName":"MicrositeThankyouGame","campaign":_vm.campaign}}),(_vm.survey)?_c('Survey',{staticStyle:{"height":"fit-content","z-index":"1"},style:({
      paddingTop: _vm.isShowFloatTop ? '52px' : '0px',
    }),attrs:{"survey":_vm.survey}}):_vm._e(),_c('div',{staticClass:"w-100 d-flex justify-center",staticStyle:{"z-index":"1"}},[_c('div',{staticClass:"table-show",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"w-100 px-4 pt-4"},[(_vm.thankyouSetting.useImageItem || _vm.thankyouSetting.useTextItem)?_c('div',{staticClass:"d-flex align-center flex-column",staticStyle:{"gap":"8px"}},[(_vm.thankyouSetting.useImageItem && _vm.thankyouSetting.imageItem)?_c('img',{staticStyle:{"width":"40%","object-fit":"contain"},attrs:{"src":_vm.thankyouSetting.imageItem}}):_vm._e(),(_vm.thankyouSetting.useTextItem && _vm.thankyouSetting.textItem)?_c('div',{staticClass:"mb-3 d-flex justify-center align-center",staticStyle:{"width":"60%"},style:({
              color: _vm.thankyouSetting.textItemColor,
              fontSize: `${_vm.thankyouSetting.textItemSize}px`,
            })},[_vm._v(" "+_vm._s(_vm.thankyouSetting.textItem)+" ")]):_vm._e()]):_vm._e(),_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.formatHtmlDetail(_vm.thankyouSetting.textDescription))}})]),_c('div',{staticClass:"w-100 px-4 my-10"},[_c('v-btn',{staticClass:"w-100",staticStyle:{"text-transform":"unset !important"},style:({
            color: _vm.thankyouSetting.colorTextAction,
            backgroundColor: _vm.thankyouSetting.bgColorTextAction,
          }),attrs:{"data-testid":"btn-back"},on:{"click":_vm.handleSubmit}},[_vm._v(_vm._s(_vm.thankyouSetting.textAction))])],1)])]),_c('div',{style:({
      position: 'absolute',
      zIndex: 2,
      top: 0,
      left: 0,
      right: 0,
      bottom: '20%',
      pointerEvents: 'none',
    }),attrs:{"id":"container_confetti"}},[(_vm.isFirework)?_c('Firework'):_vm._e(),(false)?_c('canvas',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"myConfettiCanvas"}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }